<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'ZONES.LBL_TRANSLADOZONES' | translate}}</h1>
  </div>
</div>

<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-5 lg:col-5">
      <div class="card card-w-title">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <label>{{ 'ZONES.LBL_ESTRUCTURAACTUAL' | translate}}</label>
            <p-dropdown disableTab  id="estActual" name="estActual" #NGestActual="ngModel"
                        [options]="dropEstructuraActual"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        [filter]="true"
                        (onChange)="cambiarEstructura($event.value, true)"
                        [(ngModel)]="valEstructuraActual"
                        placeholder="{{'LBL_SELECCIONE' | translate}}"
            ></p-dropdown>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-listbox [options]="zonaActual" [(ngModel)]="zonaA" filter="filter" optionLabel="nombre" *ngIf="!guaZonas" class="p-picklist-pl-unset" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                       emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
            </p-listbox>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2 text-center" style="margin-top: 100px;" *ngIf="!validandoIndicador">
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-right" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton (click)="trasladarZona(zonaA, valEstructuraTraslado, false)"></button>
      <br><br>
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-left" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton (click)="trasladarZona(zonaB , valEstructuraActual, true)"></button>
    </div>
    <div class="col-12 md:col-2 lg:col-2 text-center" style="margin-top: 100px;" *ngIf="validandoIndicador">
      <i class="fa fa-refresh fa-spin fa-fw"></i>
      <span>{{ 'LBL_VALIDANDO' | translate}}...</span>
    </div>
    <div class="col-12 md:col-5 lg:col-5">
      <div class="card card-w-title">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <label for="estTraslado">{{ 'ZONES.LBL_ESTRUCTURALTRASLADO' | translate}}</label>
            <p-dropdown disableTab  id="estTraslado" name="estTraslado" #NGestTraslado="ngModel"
                        [options]="dropEstructuraDestino"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        [filter]="true"
                        (onChange)="cambiarEstructura($event.value, false)"
                        [(ngModel)]="valEstructuraTraslado"
                        placeholder="{{'LBL_SELECCIONE' | translate}}"
            ></p-dropdown>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-listbox [options]="zonaDestino" [(ngModel)]="zonaB" filter="filter" optionLabel="nombre" *ngIf="!guaZonas" class="p-picklist-pl-unset"
                       emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                       emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
            </p-listbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-eraser" label="{{'ZONES.BTN_LIMPIARSELECCIONADOS'  | translate }}"
              type="button" (click)="limpiar()"
              pButton></button>
    </div>
  </div>
</div>


<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mosDialogo"
          header="{{ 'ZONES.LBL_TRANSLADOZONES' | translate}}"
          [modal]="true">
  <div class="grid" *ngIf="carInformacionDialogo">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>
  <div class="grid form-group" *ngIf="!carInformacionDialogo">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12">
          {{ 'ZONES.MSG_TRASLADAR' | translate }}
        </div>
      </div>
      <form [formGroup]="formulario" (ngSubmit)="cambiarNombre()" novalidate id="fZonas" name="fZonas">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'ZONES.LBL_NOMBRE' | translate }}</label>
              <label class="falso-combo-texto">{{zonSeleccionada.nombre}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'ZONES.LBL_NUEVONOMBRE' | translate }}</label>
              <input type="text" pInputText id="nombre"
                     name="nomNombre"
                     autocomplete="off"
                     formControlName="nombre"
                     [maxlength]="50"
                     capitalize-reactive
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                {{ 'ZONES.LBL_NUEVONOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
              <div class="p-message p-messages-error p-corner-all" *ngIf="exiNombre">
                {{ 'ZONES.MSG_EXISTENOMBRE' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guaZonas">
              <a (click)="regZonas()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-plus"
                      label="{{'BTN_ACEPTAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guaZonas">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
